import { render, staticRenderFns } from "./memberCard.vue?vue&type=template&id=8c23396e&scoped=true&"
import script from "./memberCard.vue?vue&type=script&lang=js&"
export * from "./memberCard.vue?vue&type=script&lang=js&"
import style0 from "./memberCard.vue?vue&type=style&index=0&id=8c23396e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c23396e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c23396e')) {
      api.createRecord('8c23396e', component.options)
    } else {
      api.reload('8c23396e', component.options)
    }
    module.hot.accept("./memberCard.vue?vue&type=template&id=8c23396e&scoped=true&", function () {
      api.rerender('8c23396e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customChildren/memberCard.vue"
export default component.exports